import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import OfferDetailsView from "../Marketing/offerPreview";
import { useDispatch } from "react-redux";
import { Collapse, message, Modal } from "antd";
import { getPurchaseOrderEvolution } from "../../core/api/products";
// import { predictStockForVariations } from "../../core/utilities/functions";
import { X } from "react-feather";
import MailDateCard from "./components/MailDateCard";
import PrinterStockCard from "./components/PrinterStockCard";
import OrderEvolution from "./components/OrderEvolution";
import ListsBlock from "./components/ListsBlock";
import CostsCard from "./components/CostsCard";
import CampaignsPanel from "./components/CampaignsPanel";
import SupportInfoPanel from "./components/SupportInfoPanel";
import {
  createMediaPlan,
  getStrategies,
  getMediaPlanById,
  updateMediaPlan,
  createItemEstimation,
  updateItemEstimation,
  getTopLists,
  // getRankedTopLists,
  deleteMediaPlan,
  bulkCreateMediaPlanListSegments,
} from "../../core/api/mediaplan";
// import { getOfferById } from "../../core/api/marketing";
import { setSelectedClients } from "../../core/redux/action";
import { getInventoryByVariations } from "../../core/api/products";
import {
  getSuppliersByType,
  getAllStatus,
  fetchBrandsBySelectedClients,
} from "../../core/api/settings";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import ProductStockTable from "./components/ProductStockTable";
import {
  getProductsByBrand,
  getConfirmedProductVariationsByProductId,
  // getProductUniverseById,
} from "../../core/api/products";
import { getMarketingsByProductVariation } from "../../core/api/marketing";
import { getProductRelatedCampaignCount } from "../../core/api/mediaplan";
import { getProductById } from "../../core/api/products";
import { validateCampaign, generateForCampaignNew } from "./functions";
import { getPrintStockBatchByOffers } from "../../core/api/products";
// import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { PanelGroup, Panel as Panel2, PanelResizeHandle } from "react-resizable-panels";
// import { getLatestCostBySupplier } from "../../core/api/mediaplan";

// Create a cache for marketing data by product variation
const marketingCache = new Map();
const CACHE_EXPIRY_TIME = 10 * 60 * 1000; // 10 minutes

// Helper function to get cached marketing data or fetch if not available
const getCachedMarketingsByProductVariation = async (variationId) => {
  const cacheKey = `marketing_${variationId}`;
  const now = Date.now();

  // Check if we have valid cached data
  if (marketingCache.has(cacheKey)) {
    const cached = marketingCache.get(cacheKey);
    if (now - cached.timestamp < CACHE_EXPIRY_TIME) {
      console.log(`Using cached marketing data for variation ${variationId}`);
      return cached.data;
    } else {
      // Remove expired cache entry
      marketingCache.delete(cacheKey);
    }
  }

  // Fetch fresh data
  console.log(`Fetching fresh marketing data for variation ${variationId}`);
  try {
    const response = await getMarketingsByProductVariation(variationId);
    const data = response.data;

    // Cache the result
    marketingCache.set(cacheKey, {
      data: data,
      timestamp: now,
    });

    return data;
  } catch (error) {
    console.error(`Error fetching marketing data for variation ${variationId}:`, error);
    throw error;
  }
};

// Batch preload marketing data for multiple variations
const preloadMarketingData = async (variationIds) => {
  const promises = variationIds.map((id) =>
    getCachedMarketingsByProductVariation(id).catch((err) => {
      console.warn(`Failed to preload marketing data for variation ${id}:`, err);
      return null;
    })
  );

  try {
    await Promise.all(promises);
    console.log(`Preloaded marketing data for ${variationIds.length} variations`);
  } catch (error) {
    console.warn("Some marketing data failed to preload:", error);
  }
};

// Clear marketing cache for specific variations or all
const clearMarketingCache = (variationIds = null) => {
  if (variationIds) {
    variationIds.forEach((id) => {
      marketingCache.delete(`marketing_${id}`);
    });
    console.log(`Cleared marketing cache for ${variationIds.length} variations`);
  } else {
    marketingCache.clear();
    console.log("Cleared all marketing cache");
  }
};
// import { getMediaPlanListSegments } from "../../core/api/mediaplan";
import { getListById, getSegments } from "../../core/api/mediaplan";

const { Panel } = Collapse;
function debounce(fn, delay) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
}
const EditMediaPlan = () => {
  // const navigate = useNavigate();

  // pull the three bits out of /media-plans/campaign/:mode/:clientId/:mediaPlanId?
  const { mode: urlMode, clientId: urlClientId, mediaPlanId: urlMediaPlanId } = useParams();
  // const [collapsed, setCollapsed] = useState(false);

  const selectedClients = useSelector((state) => state.selectedClients);
  const [currentClientId, setCurrentClientId] = useState(
    urlClientId ||
      (selectedClients.length === 1 && selectedClients[0] !== "all" ? selectedClients[0] : null)
  );
  const [campaigns, setCampaigns] = useState([
    {
      id: null,
      code: "",
      brand: null,
      product: null,
      variation: null,
      mailQty: null,
      actualMailQty: null,
      rateOfResponse: null,
      mailDate: null,
      offer: null,
      printer: null,
      strategy: null,
      strategyDesc: "",
      status: null,
      statusDesc: "",
      itemEstimation: [],
      mailStockData: [],
      printStockData: [],
      productOptions: [],
      variationOptions: [],
      printerOptions: [],
      offerOptions: [],
      clientIds: [currentClientId],
      isGeneratingActions: false,
      suggestedActions: {},
      lettershopCostRef: null,
      postageCostRef: null,
      dataProcessingCostRef: null,
      costs: {
        printingCost: 0,
        lettershopCost: 0,
        postageCost: 0,
        dataProcessingCost: 0,
        miscFee: 0,
        merchantFee: 0,
        productCost: 0,
        callCenterCost: 0,
        shippingCost: 0,
        fulfillmentCost: 0,
        royalty: 0,
        refundCost: 0,
        listsCost: 0,
      },
    },
  ]);
  const [productStock, setProductStock] = useState([]);
  const [isOfferDetailsVisible, setIsOfferDetailsVisible] = useState(false);
  const [selectedOfferId, setSelectedOfferId] = useState(null);
  const offerDetailsSidebarRef = useRef(null);
  const [, setOfferDetailsSidebarWidth] = useState(0);
  // const [rankedLists, setRankedLists] = useState([]);
  const [fullLists, setFullLists] = useState([]);
  // const [alllistOptions, setallListOptions] = useState([]);
  const [addedLists, setAddedLists] = useState([]);

  // this use useEffect does not fetch and only use localstates
  useEffect(() => {
    const draft = sessionStorage.getItem("mediaPlanDraft");
    if (draft) {
      try {
        const parsed = JSON.parse(draft);
        if (Array.isArray(parsed)) {
          setCampaigns(parsed);
        } else if (parsed.campaigns && Array.isArray(parsed.campaigns)) {
          // setCampaigns(parsed.campaigns);
          setCampaigns(
            parsed.campaigns.map((c) => ({
              ...c,
              mailDate: c.mailDate ? dayjs(c.mailDate) : null,
            }))
          );
          console.log("setting list on load", parsed.addedLists);

          setAddedLists(parsed.addedLists || []);
        }
      } catch (e) {
        console.warn("Invalid session draft:", e);
      }
    }
  }, []);

  // this useEffect fetches getInventory by variation IDs
  useEffect(() => {
    const allVariationIds = campaigns
      .flatMap((c) => c.itemEstimation.map((i) => i.product_variation_id))
      .filter((v, i, arr) => v != null && arr.indexOf(v) === i);

    if (allVariationIds.length === 0) {
      setProductStock([]);
      return;
    }
    setUniqueVariationIds(allVariationIds);

    (async () => {
      try {
        const response = await getInventoryByVariations(allVariationIds);

        setProductStock(response.data);
      } catch (err) {
        console.error("Failed to fetch global product stock:", err);
        message.error("Could not load product stock for all campaigns.");
      }
    })();
  }, [
    campaigns
      .map((c) =>
        c.itemEstimation.map((i) => `${i.product_variation_id}:${i.qtyPerOrder}`).join(",")
      )
      .join(";"),
  ]);

  useEffect(() => {
    if (urlMode === "create") {
      const saveDraft = debounce((campaigns, addedLists) => {
        sessionStorage.setItem("mediaPlanDraft", JSON.stringify({ campaigns, addedLists }));
      }, 1);
      saveDraft(campaigns, addedLists);
    }
  }, [campaigns, addedLists, urlMode]);

  const [isSaving] = useState(false);
  const handleDuplicateCampaign = (idx) => {
    let baseCode = campaigns[0].code.replace(/(_[A-Z])$/, "");
    if (/_[A-Z]$/.test(campaigns[0].code)) {
      baseCode = campaigns[0].code.slice(0, -2);
    }

    const campaignToClone = campaigns[idx];

    const newCampaign = {
      ...campaignToClone,
      id: null,
      itemEstimation: campaignToClone.itemEstimation
        ? campaignToClone.itemEstimation.map((item) => ({
            ...item,
            id: null,
          }))
        : [],
    };

    const updatedCampaigns = [...campaigns, newCampaign];

    const suffixed = updatedCampaigns.map((c, i) => ({
      ...c,
      code: `${baseCode}_${String.fromCharCode(65 + i)}`,
    }));

    setCampaigns(suffixed);
  };

  // This function was removed to avoid duplication with the enhanced version below
  const handleSaveCampaign = async (idx) => {
    const campaign = campaigns[idx];

    if (!validateCampaign(campaign)) return;
    console.log(campaign, "campaign all");
    const mpPayload = {
      date: dayjs(campaign.mailDate).format("YYYY-MM-DD"),
      strategy_id: campaign.strategy?.value || campaign.strategy,
      strategy_description: campaign.strategyDescription,
      offer: campaign.offer?.id,
      target_mail_qty: campaign.mailQty,
      actual_mail_qty: campaign.actualMailQty,
      target_rate_of_response: campaign.rateOfResponse,
      printer_id: campaign.printer?.value || campaign.printer,
      status_id: campaign.status?.value || campaign.status,
      status_description: campaign.statusDescription,
      campaign_code: campaign.code,
      lettershop_cost_ref_id: campaign.lettershopCostRef?.id,
      postage_cost_ref_id: campaign.postageCostRef?.id,
      data_processing_cost_ref_id: campaign.dataProcessingCostRef?.id,
      printing_cost: campaign.costs.printingCost,
      lettershop_cost: campaign.costs.lettershopCost,
      printer_cost: campaign.costs.printerCost,
      postage_cost: campaign.costs.postageCost,
      data_processing_cost: campaign.costs.dataProcessingCost,
      misc_fee: campaign.costs.miscFee,
      merchant_fee: campaign.costs.merchantFee,
      product_cost: campaign.costs.productCost,
      call_center_cost: campaign.costs.callCenterCost,
      shipping_cost: campaign.costs.shippingCost,
      fulfillment_cost: campaign.costs.fulfillmentCost,
      royalty: campaign.costs.royalty,
      refund_cost: campaign.costs.refundCost,
      lists_cost: campaign.costs.listsCost,
      product_id: campaign.product,
    };

    let mpResponse;
    try {
      if (campaign.id) {
        mpResponse = await updateMediaPlan(campaign.id, mpPayload);
        // console.log(mpPayload, "mpPayload1");
        // console.log(mpResponse, "mpResponse:");
        message.success(`Campaign ${campaign.code} updated.`);
      } else {
        mpResponse = await createMediaPlan(mpPayload);
        // console.log(mpPayload, "mpPayload2");
        // console.log(mpResponse, "mpResponse:");
        message.success(`Campaign ${campaign.code} created.`);
        handleCampaignChange(idx, "id", mpResponse.data.id);
      }
    } catch (err) {
      console.error(err);
      message.error(`Could not save media plan: ${err.response?.data?.detail || err.message}`);
      return;
    }

    const mediaPlanId = mpResponse.data.id;

    for (const item of campaign.itemEstimation) {
      const iePayload = {
        media_plan: mediaPlanId,
        product_variation: item.product_variation_id,
        qty_per_order: item.qtyPerOrder,
      };

      try {
        if (item.id) {
          await updateItemEstimation(item.id, iePayload);
        } else {
          const created = await createItemEstimation(iePayload);
          handleCampaignChange(
            idx,
            "itemEstimation",
            campaigns[idx].itemEstimation.map((r) =>
              r === item ? { ...r, id: created.data.id } : r
            )
          );
        }
      } catch (err) {
        console.error("Failed to save item estimation:", err);
        message.error(
          `Error saving estimation for ${item.offer_item_description}: ${
            err.response?.data?.detail || err.message
          }`
        );
      }
    }
    console.log("going to add segment");
    try {
      const listSegments = addedLists.map((list) => ({
        list_id: list.list_id,
        segment_id: list.segment_id || "",
        priority: list.priority,
        test_cont:
          typeof list.selectTestCont === "object" ? list.selectTestCont.label : list.selectTestCont,
        order_qty: list.orderQty,
        ship_qty: list.shipQty,
        mail_qty: list.mailQty,
        max_all:
          typeof list.selectMaxAll === "object" ? list.selectMaxAll.label : list.selectMaxAll,
        comment: list.comment,
        product_category:
          typeof list.productCategory === "object" ? list.productCategory : list.productCategory,
        performance: list.performance,
        cost: list.cost,
        source_code: list.source_code,
      }));
      console.log("listSegments", listSegments, addedLists);

      if (listSegments.length > 0) {
        console.log("going to add segment");
        await bulkCreateMediaPlanListSegments(mediaPlanId, listSegments);
        message.success(`List segments saved for campaign ${campaign.code}.`);
      }
    } catch (err) {
      console.error("Failed to save list segments:", err);
      message.error(`Error saving list segments: ${err.response?.data?.detail || err.message}`);
    }
  };

  const handleSaveAllCampaigns = async () => {
    campaigns.forEach(async (campaign, idx) => {
      await handleSaveCampaign(idx);
    });
    message.success("All campaigns saved!");
    sessionStorage.removeItem("mediaPlanDraft");
    // window.location.reload();
  };

  const renderCampaignInfoPanel = () => {
    const seenDates = new Set();
    return campaigns.reduce((panels, campaign) => {
      const { mailDate, brand } = campaign;
      if (mailDate && !seenDates.has(mailDate)) {
        seenDates.add(mailDate);
        panels.push(<MailDateCard key={mailDate} mailDate={mailDate} brand_id={brand} />);
      }
      return panels;
    }, []);
  };

  // Fetch data for dropdowns
  // Fetch product universe for the selected product via productId
  useEffect(() => {
    fetchProductUniverseForProduct();
  }, [campaigns]);

  const fetchProductUniverseForProduct = async () => {
    const productId = campaigns?.[0]?.product;
    if (!productId) return;

    try {
      const res = await getProductById(productId);
      const product = res.data;
      setProductCategory(product.product_universe_name);
    } catch (error) {
      console.error("Failed to fetch product universe", error);
    }
  };

  // console.log("campaigns", campaigns);
  // console.log("productID", campaigns?.[0]?.product);

  const renderProductStockPanel = () => <ProductStockTable productStock={productStock} />;
  const renderPrintersStockPanel = () => <PrinterStockCard printstockData={printStockData} />;
  const renderOrderEvolutionPanel = () => (
    <OrderEvolution buildPurchaseOrderEvolutionTable={buildPurchaseOrderEvolutionTable} />
  );
  const renderCostsPanel = () => (
    <Collapse
      bordered={false}
      // open all panels by default (or pick one)
      defaultActiveKey={campaigns.map((c) => c.code)}
      style={{ background: "none" }}
      className="small-font">
      {campaigns.map((campaign) => (
        <Panel key={campaign.code} header={`Costs for campaign: ${campaign.code}`}>
          <CostsCard cost={campaign.costs} />
        </Panel>
      ))}
    </Collapse>
  );

  const [uniqueVariationIds, setUniqueVariationIds] = useState([]);
  // const [isSidebarVisible, setSidebarVisible] = useState(false);
  // const [clickedOfferId, setClickedOfferId] = useState(null);
  const dispatch = useDispatch();
  const [modalProps] = useState({
    title: "",
    onSubmit: null,
  });
  const [strategyOptions, setStrategyOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedList, setSelectedList] = useState(null);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [priority, setPriority] = useState("1");
  // const [orderQty, setOrderQty] = useState("");
  const [shipQty, setShipQty] = useState("");
  const [mailQty, setMailQty] = useState("");
  const [selectTestCont, setSelectTestCont] = useState({
    value: "Cont.",
    label: "Cont.",
  });
  const [selectMaxAll, setSelectMaxAll] = useState({
    value: "All",
    label: "All",
  });
  const [comment, setComment] = useState("");
  const [sourceCode, setSourceCode] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [performance, setPerformance] = useState("");
  const [cost, setCost] = useState("");

  const [lists, setLists] = useState([]);
  // const sidebarRef = useRef(null);
  // const [isRightSideBarEditMode, setIsRightSideBarEditMode] = useState(false);
  const [printStockData, setPrintStockData] = useState([]);
  const [purchaseOrderEvolution, setPurchaseOrderEvolution] = useState([]);
  // const [suggestedActions, setSuggestedActions] = useState({});
  // const [isGeneratingActions, setIsGeneratingActions] = useState(false);
  const [allSegments, setAllSegments] = useState([]);

  const offerIds = useMemo(
    () => campaigns.map((c) => c.offer?.id).filter((id) => id != null),
    [campaigns]
  );
  const offerKey = offerIds.join(",");

  useEffect(() => {
    async function fetchPrintStockBatchByOffers() {
      if (!offerIds.length) return;

      try {
        const response = await getPrintStockBatchByOffers(offerIds);
        setPrintStockData(response.data);
        setCampaigns((prev) => {
          const copy = [...prev];
          copy.forEach((camp) => {
            const printStockData = response.data.find((d) => d.offer_id === camp.offer?.id);
            if (printStockData) {
              camp.printStockData = printStockData;
            }
          });
          return copy;
        });
      } catch (error) {
        console.error("Error fetching print stock by offers:", error);
      }
    }

    fetchPrintStockBatchByOffers();
  }, [offerKey]);

  useEffect(() => {
    const fetchPurchaseOrderEvolution = async () => {
      try {
        if (uniqueVariationIds.length === 0) return;
        const response = await getPurchaseOrderEvolution([currentClientId], uniqueVariationIds);
        setPurchaseOrderEvolution(response.data);
      } catch (error) {
        console.error("Error fetching purchase order evolution:", error);
      }
    };

    if (currentClientId && uniqueVariationIds.length > 0) {
      fetchPurchaseOrderEvolution();
    }
  }, [currentClientId, uniqueVariationIds]);



  const buildPurchaseOrderEvolutionTable = () => {
    const dynamicColumns = [
      {
        title: "Product Variation",
        dataIndex: "product_variation_code",
        key: "product_variation_code",
        fixed: "left",
        width: 200,
      },
      {
        title: "Current Stock",
        dataIndex: "current_stock",
        key: "current_stock",
        width: 120,
      },
    ];

    const dataSource = [];
    let maxOrders = 0;

    purchaseOrderEvolution.forEach((record) => {
      const row = {
        key: record.product_variation_code,
        product_variation_code: record.product_variation_code,
        current_stock: record.current_stock,
      };

      let cumulativeTotal = record.current_stock;

      record.orders.forEach((order, idx) => {
        const expectedDelivery = dayjs(order.invoice_date).add(60, "day").format("YYYY-MM-DD");

        cumulativeTotal += order.quantity;

        row[`order_qty_${idx}`] = order.quantity;
        row[`invoice_date_${idx}`] = order.invoice_date;
        row[`expected_delivery_${idx}`] = expectedDelivery;
        row[`cumulative_total_${idx}`] = cumulativeTotal;
      });

      maxOrders = Math.max(maxOrders, record.orders.length);
      dataSource.push(row);
    });

    for (let i = 0; i < maxOrders; i++) {
      dynamicColumns.push({
        title: `Order ${i + 1}`,
        key: `order_group_${i}`,
        children: [
          {
            title: "Invoice Date",
            dataIndex: `invoice_date_${i}`,
            key: `invoice_date_${i}`,
            width: 150,
          },
          {
            title: "Qty",
            dataIndex: `order_qty_${i}`,
            key: `order_qty_${i}`,
            width: 100,
          },
          {
            title: "Expected Delivery",
            dataIndex: `expected_delivery_${i}`,
            key: `expected_delivery_${i}`,
            width: 160,
          },
          {
            title: "Total After Order",
            dataIndex: `cumulative_total_${i}`,
            key: `cumulative_total_${i}`,
            width: 160,
          },
        ],
      });
    }

    return { columns: dynamicColumns, data: dataSource };
  };

  const testContOptions = [
    { value: "Test", label: "Test" },
    { value: "Cont.", label: "Cont." },
  ];

  const maxAllOptions = [
    { value: "Max", label: "Max" },
    { value: "All", label: "All" },
  ];

  // this useEffect fetches lists
  useEffect(() => {
    fetchLists();
  }, []);

  useEffect(() => {
    if (selectedClients.length === 0) {
      message.warning("Please select a client.");
      return;
    }

    if (selectedClients.length > 1) {
      message.warning("Please select one client.");
      return;
    }

    if (selectedClients[0] === "all") {
      message.warning("Please select one client.");
      return;
    }
    setCurrentClientId(selectedClients[0]);
  }, [selectedClients]);

  const fetchLists = async () => {
    try {
      const response = await getTopLists();
      setLists(response.data);
      console.log("Fetched top lists:", response.data);
    } catch (error) {
      console.error("Error fetching lists:", error);
    }
  };

  const listOptions = useMemo(() => {
    return (lists || []).map((list) => ({
      value: list.id,
      label: list.name,
    }));
  }, [lists]);

  const handleListCreated = async (newList) => {
    try {
      const res = await getListById(newList.id);
      const fullList = res.data;
      setFullLists((prev) => {
        const filtered = prev.filter((l) => l.id !== fullList.id);
        return [...filtered, fullList];
      });

      // Select new list, reset segment
      const option = { value: fullList.id, label: fullList.name };
      setSelectedList(option);
      setSelectedSegment(null); // trigger segment re-compute
    } catch (error) {
      console.error("Error in handleListCreated", error);
    }
  };

  // moved the function declaration outside of the useEffect.
  // use useEffect runs on load as campaign product changes
  // Also better to use useCallback for fetchRankedLists
  useEffect(() => {
    const productId = campaigns?.[0]?.product;
    if (!productId) return;
    // we do not have ranked-top-list url on the backend.
    // this has been commented momentarily by zaman
    // fetchRankedLists();
  }, [campaigns?.[0]?.product]);

  // this has been commented momentarily by zaman
  // const fetchRankedLists = useCallback(async () => {
  //   console.log("Fetching ranked lists first time...");
  //   try {
  //     const response = await getRankedTopLists(productId);
  //     setRankedLists(response.data);
  //   } catch (error) {
  //     console.error("Error fetching ranked top lists:", error);
  //   }
  // }, [campaigns?.[0]?.product]);

  const segmentOptions = selectedList
    ? (lists.find((list) => list.id === selectedList.value)?.segments || []).map((segment) => ({
        value: segment.id,
        label: segment.name,
      }))
    : [];

  // this is commented by Zaman as seen duplicate
  // The below useEffect redundent was removed.
  const fetchSegments = async () => {
    console.log("Fetching segments...");
    try {
      const response = await getSegments();
      setAllSegments(response.data);
    } catch (err) {
      console.error("Failed to fetch segments:", err);
    }
  };

  // useEffect(() => {
  //   fetchSegments(); // initially load segments
  // }, []);

  const AlllistOptions = useMemo(() => {
    return (fullLists || []).map((list) => ({
      value: list.id,
      label: list.name,
    }));
  }, [fullLists]);

  const segmentAllOptions = useMemo(() => {
    if (!selectedList) return [];

    return allSegments
      .filter((seg) => seg.list === selectedList.value)
      .map((seg) => ({
        value: seg.id,
        label: seg.name,
      }));
  }, [selectedList, allSegments]);

  const handleSaveList = (directListData) => {
    if (directListData) {
      console.log("directListData", directListData, mailQty, shipQty);
      // Make sure orderQty is set from mailed_quantity or shipQty
      const newListData = {
        ...directListData,
        id: `list-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        // Use mailed_quantity as orderQty if available, otherwise use shipQty or existing orderQty
        orderQty: mailQty || directListData.shipQty || directListData.orderQty || 0,
        shipQty,
        mailQty,
      };

      console.log("Adding list from directListData:", newListData);
      setAddedLists((prevLists) => [...prevLists, newListData]);
      console.log("Added list from directListData:", addedLists);
      return;
    }

    if (!selectedList) return;

    // ✅ Try to get full list details from fullLists or fallback to lists
    let listDetails = fullLists.find((list) => list.id === selectedList.value);

    // If fullList fails, try using 'lists' which has only label/value
    if (!listDetails) {
      const fallback = lists.find((item) => item.value === selectedList.value);
      if (fallback) {
        listDetails = {
          id: fallback.value,
          name: fallback.label,
          segments: [], // set empty if not available
        };
      }
    }

    if (!listDetails) {
      console.error("List details not found in either source");
      return;
    }

    let segmentDetails = null;
    let segmentId = null;
    let segmentName = null;

    if (selectedSegment) {
      segmentDetails = listDetails.segments?.find(
        (segment) => segment.id === selectedSegment.value
      );
      segmentId = selectedSegment.value;
      segmentName = segmentDetails?.name || "";
    }
    // console.log("segmentDetails", segmentDetails);
    const newListData = {
      id: `list-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      list_id: selectedList.value,
      list_name: listDetails.name,
      list_full: listDetails,
      segment_id: segmentId || "",
      segment_name: segmentName || "",
      period: segmentDetails?.period || "",
      quantity: segmentDetails?.quantity || 0,
      category: segmentDetails?.category || "",
      date_released: segmentDetails?.date_released || "-",
      priority,
      selectTestCont: selectTestCont?.label || "",
      orderQty: shipQty, // Set orderQty to match shipQty
      shipQty,
      mailQty,
      selectMaxAll: selectMaxAll?.label || "",
      comment,
      productCategory,
      source_code: sourceCode,
      performance,
      cost,
    };
    console.log("newListData", newListData);

    setLists((prev) => [...prev, newListData]);

    setAddedLists((prevLists) => [...prevLists, newListData]);
    console.log("Added list from directListData:", addedLists);

    // Reset form
    // setSelectedList(null);
    // setSelectedSegment(null);
    // setPriority("1");
    // setSelectTestCont({ value: "Cont.", label: "Cont." });
    // setOrderQty("");
    // setShipQty("");
    // setMailQty("");
    // setSelectMaxAll({ value: "All", label: "All" });
    // setComment("");
    // setPerformance("");
    // setCost("");
  };

  const handleRemoveList = (listId) => {
    setAddedLists((prevLists) => prevLists.filter((list) => list.id !== listId));
  };

  const fetchStrategiesAndPrinters = async () => {
    console.log("Fetching strategies and printers...");
    try {
      const [strategiesRes, statusesRes] = await Promise.all([getStrategies(), getAllStatus()]);
      setStatusOptions(statusesRes.data.map((s) => ({ value: s.id, label: s.name })));
      setStrategyOptions(strategiesRes.data.map((s) => ({ value: s.id, label: s.strategy })));
    } catch (error) {
      console.error("Error fetching strategies or printers:", error);
      message.error("Failed to fetch strategies or printers. Please try again later.");
    }
  };

  // Fetch strategies and printers on modalProps change
  useEffect(() => {
    fetchStrategiesAndPrinters();
  }, [modalProps]);

  // Fetch brands when currentClientId changes
  // this also runs on first load as the currentClientId is set will set first the first time.

  useEffect(() => {
    const previousClientId = sessionStorage.getItem("currentClientId");
    sessionStorage.setItem("currentClientId", currentClientId);
    
    if (currentClientId) {
      // If client ID changed, remove media plan draft and reload window
      if (previousClientId && previousClientId !== currentClientId) {
        sessionStorage.removeItem("mediaPlanDraft");
        window.location.reload();
        return;
      }
      
      fetchBrands();
    }
  }, [currentClientId]);

  // optimized it by wrapping to useCallBack hook to avoid re-requests.
  const fetchBrands = useCallback(async () => {
    try {
      const response = await fetchBrandsBySelectedClients([currentClientId]);
      setBrandOptions(
        response.data.map((brand) => ({
          value: brand.id,
          label: brand.brand_name,
        }))
      );
    } catch (error) {
      console.error("Error fetching brands:", error);
      message.error("Failed to fetch brands for the selected client.");
    }
  }, [currentClientId]);

  const handleBrandChange = async (selectedBrand, idx) => {
    setCampaigns((prevCampaigns) => {
      const newCampaigns = [...prevCampaigns];
      newCampaigns[idx].brand = selectedBrand;
      return newCampaigns;
    });
    try {
      if (selectedBrand) {
        const printersRes = await getSuppliersByType("Printer", selectedBrand);
        setCampaigns((prevCampaigns) => {
          const newCampaigns = [...prevCampaigns];
          newCampaigns[idx].printerOptions = printersRes.data.map((p) => ({
            value: p.id,
            label: p.name,
          }));
          return newCampaigns;
        });

        const productOptions = await getProductsByBrand(selectedBrand);
        setCampaigns((prevCampaigns) => {
          const newCampaigns = [...prevCampaigns];
          newCampaigns[idx].productOptions = productOptions.data.map((p) => ({
            value: p.id,
            label: p.name,
          }));
          return newCampaigns;
        });
      }
    } catch (error) {
      console.error("Error fetching offers:", error);
      message.error("Failed to fetch offers for the selected product variation.");
    }
  };

  const handleProductChange = async (selectedProduct, idx) => {
    console.log(selectedProduct, idx, "product2", campaigns);
    setCampaigns((prevCampaigns) => {
      const newCampaigns = [...prevCampaigns];
      newCampaigns[idx].product = selectedProduct;
      newCampaigns[idx].itemEstimation = [];
      return newCampaigns;
    });
    try {
      if (selectedProduct) {
        const [
          variationsRes,
          productCampaignCountRes,
          productCodeRes,
          // topListsRes
        ] = await Promise.all([
          getConfirmedProductVariationsByProductId(selectedProduct),
          getProductRelatedCampaignCount(selectedProduct),
          getProductById(selectedProduct),
          // getTopLists(selectedProduct),
        ]);

        const productCampaignCount = productCampaignCountRes.data.count;
        const productCode = productCodeRes.data.product_code;

        // setLists(topListsRes.data);

        setSelectedList(null);
        setSelectedSegment(null);

        setCampaigns((prevCampaigns) => {
          const newCampaigns = [...prevCampaigns];
          newCampaigns[idx].variationOptions = variationsRes.data.map((v) => ({
            value: v.id,
            label: v.product_variation_desc,
          }));
          if (variationsRes.data.length === 1) {
            newCampaigns[idx].variation = variationsRes.data[0].id;
            handleVariationChange(variationsRes.data[0].id, idx);
          }
          newCampaigns[idx].code = `${productCode}00${productCampaignCount + 1}`;
          return newCampaigns;
        });

        // Preload marketing data for all variations to improve performance
        const variationIds = variationsRes.data.map((v) => v.id);
        preloadMarketingData(variationIds);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      message.error("Failed to fetch data for the selected product.");
    }
  };

  const handleVariationChange = async (selectedVariation, idx) => {
    setCampaigns((prevCampaigns) => {
      const newCampaigns = [...prevCampaigns];
      newCampaigns[idx].variation = selectedVariation;
      return newCampaigns;
    });
    try {
      if (selectedVariation) {
        // Use cached version instead of direct API call
        const offersData = await getCachedMarketingsByProductVariation(selectedVariation);
        setCampaigns((prevCampaigns) => {
          const newCampaigns = [...prevCampaigns];
          newCampaigns[idx].offerOptions = offersData;
          if (offersData.length === 1) {
            newCampaigns[idx].offer = offersData[0];
          }
          return newCampaigns;
        });
      }
    } catch (error) {
      console.error("Error fetching offers:", error);
      message.error("Failed to fetch offers for the selected product variation.");
    }
  };
  const handleOfferChange = (idx, offer) => {
    setCampaigns((prevCampaigns) => {
      const newCampaigns = [...prevCampaigns];
      newCampaigns[idx].offer = offer;
      return newCampaigns;
    });
  };

  // removed the calculateCost function as it was not used anywhare in this file.
  // done by Zaman
  // const calculateCosts = async () => {  };

  const handleCampaignChange = (idx, field, value) => {
    setCampaigns((prev) => {
      const updated = [...prev];
      updated[idx] = { ...updated[idx], [field]: value };

      // If mail quantity changes, recalculate costs
      // if (field === "mailQty") {
      //   // We need to use a setTimeout to ensure the state is updated before calculating costs
      //   setTimeout(async () => {
      //     const updatedCosts = await calculateCosts(updated[idx], value);
      //     setCampaigns((current) => {
      //       const newState = [...current];
      //       newState[idx] = { ...newState[idx], costs: updatedCosts };
      //       return newState;
      //     });
      //   }, 0);
      // }

      // If supplier changes, recalculate costs if mail quantity exists
      // if (
      //   ["lettershop", "postage", "dataProcessing"].includes(field) &&
      //   updated[idx].mailQty
      // ) {
      //   setTimeout(async () => {
      //     const updatedCosts = await calculateCosts(
      //       updated[idx],
      //       updated[idx].mailQty
      //     );
      //     setCampaigns((current) => {
      //       const newState = [...current];
      //       newState[idx] = { ...newState[idx], costs: updatedCosts };
      //       return newState;
      //     });
      //   }, 0);
      // }

      return updated;
    });
  };

  // this useEffect fetches media plan details when urlMediaPlanId and currentClientId are available
  // this also fetches all dropdown options
  // this is the most costly request (process)
  useEffect(() => {
    if (urlMediaPlanId && currentClientId) {
      dispatch(setSelectedClients([currentClientId]));
      fetchMediaPlanDetails(urlMediaPlanId);
    }
  }, [urlMediaPlanId, currentClientId]);

  const fetchMediaPlanDetails = useCallback(
    async (id) => {
      try {
        const response = await getMediaPlanById(id);
        const data = response.data;
        const formattedLists = data.list_segments.map((seg) => {
          const segmentDetails = seg.segment_details || {};
          return {
            id: seg.id,
            list_id: seg.list_details.id,
            list_name: seg.list_details.name,
            segment_id: segmentDetails.id || "",
            segment_name: segmentDetails.name || "",
            period: segmentDetails.period || "",
            quantity: segmentDetails.quantity || 0,
            category: segmentDetails.category || "",
            date_released: segmentDetails.date_released || "-",
            priority: seg.priority,
            selectTestCont: { value: seg.test_cont, label: seg.test_cont },
            orderQty: seg.order_qty,
            shipQty: seg.ship_qty,
            mailQty: seg.mail_qty,
            selectMaxAll: { value: seg.max_all, label: seg.max_all },
            comment: seg.comment,
            cost: seg.cost,
            performance: seg.performance,
            productCategory: seg.product_category,
            source_code: seg.source_code,
          };
        });
        setAddedLists(formattedLists);

        const baseCampaign = {
          id: data.id,
          code: data.campaign_code,
          brand: data.offer_details.brand,
          product: data.offer_details.product_variations_detail[0].product_id,
          variation: data.offer_details.product_variations[0],
          mailQty: data.target_mail_qty,
          actualMailQty: data.actual_mail_qty,
          rateOfResponse: data.target_rate_of_response,
          mailDate: dayjs(data.date),
          offer: data.offer_details,
          printer: data.printer.id,
          strategy: data.strategy.id,
          strategyDesc: data.strategy_description,
          status: data.status.id,
          statusDesc: data.status_description,
          lettershop: data.lettershop_cost_ref_details?.supplier?.id,
          postage: data.postage_cost_ref_details?.supplier?.id,
          dataProcessing: data.data_processing_cost_ref_details?.supplier?.id,
          lettershopCostRef: data.lettershop_cost_ref_details,
          postageCostRef: data.postage_cost_ref_details,
          dataProcessingCostRef: data.data_processing_cost_ref_details,
          itemEstimation: data.item_estimations.map((e) => ({
            id: e.id,
            product_variation_id: e.product_variation,
            qtyPerOrder: e.qty_per_order,
            offer_item_description: e.product_variation_detail?.product_variation_desc,
          })),
          mailStockData: [],
          productOptions: [],
          variationOptions: [],
          printerOptions: [],
          offerOptions: [],
          clientIds: [currentClientId],
          isGeneratingActions: false,
          suggestedActions: {},
          costs: {
            printingCost: data.printing_cost || 0,
            lettershopCost: data.lettershop_cost || 0,
            printerCost: data.printer_cost || 0,
            postageCost: data.postage_cost || 0,
            dataProcessingCost: data.data_processing_cost || 0,
            miscFee: data.misc_fee || 0,
            merchantFee: data.merchant_fee || 0,
            productCost: data.product_cost || 0,
            callCenterCost: data.call_center_cost || 0,
            shippingCost: data.shipping_cost || 0,
            fulfillmentCost: data.fulfillment_cost || 0,
            royalty: data.royalty || 0,
            refundCost: data.refund_cost || 0,
            listsCost: data.lists_cost || 0,
          },
        };

        // start the slow request but don’t block
        const offerPromise = getCachedMarketingsByProductVariation(baseCampaign.variation);
        // Fetch the rest in parallel
        const [
          printersRes,
          productsRes,
          variationsRes,
          statusesRes,
          strategiesRes,
          lettershopSuppliersRes,
          postageSuppliersRes,
          dataProcessingSuppliersRes,
        ] = await Promise.all([
          getSuppliersByType("Printer", baseCampaign.brand),
          getProductsByBrand(baseCampaign.brand),
          getConfirmedProductVariationsByProductId(baseCampaign.product),
          getAllStatus(),
          getStrategies(),
          getSuppliersByType("Lettershop", baseCampaign.brand),
          getSuppliersByType("Postage", baseCampaign.brand),
          getSuppliersByType("Data Processing", baseCampaign.brand),
        ]);

        // Map options
        baseCampaign.printerOptions = printersRes.data.map((p) => ({ value: p.id, label: p.name }));
        baseCampaign.productOptions = productsRes.data.map((p) => ({ value: p.id, label: p.name }));
        baseCampaign.variationOptions = variationsRes.data.map((v) => ({
          value: v.id,
          label: v.product_variation_desc,
        }));

        // Preload marketing data for all variations to improve performance
        const allVariationIds = variationsRes.data.map((v) => v.id);
        preloadMarketingData(allVariationIds);
        baseCampaign.lettershopOptions = lettershopSuppliersRes.data.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        baseCampaign.postageOptions = postageSuppliersRes.data.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        baseCampaign.dataProcessingOptions = dataProcessingSuppliersRes.data.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        setStatusOptions(statusesRes.data.map((s) => ({ value: s.id, label: s.name })));
        setStrategyOptions(strategiesRes.data.map((s) => ({ value: s.id, label: s.strategy })));

        // Set campaigns without offers (fast data first)
        setCampaigns([baseCampaign]);

        //  Once offers resolve, update campaign state with them
        offerPromise
          .then((offersData) => {
            setCampaigns((prev) =>
              prev.map((c) => (c.id === baseCampaign.id ? { ...c, offerOptions: offersData } : c))
            );
          })
          .catch((err) => {
            console.error("Error fetching offers for media plan:", err);
            message.error("Failed to fetch offers. Please try again.");
          });
      } catch (err) {
        console.error("Error fetching media plan details:", err);
        message.error("Failed to fetch media plan details. Please try again.");
      }
    },
    [currentClientId, urlMediaPlanId]
  );

  const transformedLists = addedLists.map((list, index) => ({
    key: `${list.id}-${index}`,
    list_name: list.list_name,
    segment_name: list.segment_name,
    period: list.period,
    quantity: list.quantity,
    category: list.category,
    date_released: list.date_released,
    priority: list.priority,
    selectTestCont: list.selectTestCont,
    orderQty: list.orderQty,
    shipQty: list.shipQty,
    mailQty: list.mailQty,
    selectMaxAll: list.selectMaxAll,
    comment: list.comment,
    source_code: list.source_code,
    productCategory: list.productCategory,

    performance: list.performance,
    cost: list.cost,
    action: (
      <button
        className="btn btn-danger btn-sm"
        onClick={(e) => {
          e.preventDefault();
          handleRemoveList(list.id);
        }}>
        <X size={14} />
      </button>
    ),
  }));

  // Keep track of the last key for each campaign to avoid unnecessary regeneration
  const [lastActionKeys, setLastActionKeys] = useState({});

  const generatingNewActions = () => {
    campaigns.forEach((camp, idx) => {
      const key = [
        camp.mailDate,
        camp.clientIds.join(","),
        camp.itemEstimation.map((i) => i.product_variation_id + ":" + i.qtyPerOrder).join(","),
        camp.mailStockData.map((d) => d.stock + ":" + d.needed).join(","),
        camp.targetMailQty,
      ].join("|");

      // Check if this key matches the last one we processed for this campaign
      // If it's the same, skip regeneration
      // Mark as loading
      setCampaigns((cs) => {
        const copy = [...cs];
        copy[idx] = { ...copy[idx], isGeneratingActions: true };
        return copy;
      });

      // Extract variation IDs from the campaign's item estimations
      const variationIds = camp.itemEstimation.map(
        (item) => item.product_variation_id || item.variation
      );

      // Set start date to mail date and end date to 100 days later
      const startDate = dayjs(camp.mailDate);
      const endDate = startDate.add(100, "day");

      // Create an AbortController for the request
      const controller = new AbortController();

      // Generate actions for the campaign with the same pattern as ProductStockEvolution
      generateForCampaignNew(camp, variationIds, startDate, endDate, {
        signal: controller.signal,
      })
        .then((actions) => {
          // Store the key we just processed
          setLastActionKeys((prev) => ({
            ...prev,
            [idx]: key,
          }));

          // Check if there are any actions to display
          const hasActions = Object.values(actions).some(
            (actionArray) => Array.isArray(actionArray) && actionArray.length > 0
          );

          // If no actions are needed, we should clear the loading state
          // and not show any suggested actions
          setCampaigns((cs) => {
            const copy = [...cs];
            copy[idx] = {
              ...copy[idx],
              suggestedActions: hasActions ? actions : {},
              isGeneratingActions: false,
            };
            return copy;
          });

          // Log for debugging
          if (!hasActions) {
            console.log(`No actions needed for campaign ${idx}`);
          }
          console.log("here in generating actions 4");
        })

        .catch((err) => {
          console.error("Action generation failed for campaign", idx, err);
          setCampaigns((cs) => {
            const copy = [...cs];
            copy[idx] = { ...copy[idx], isGeneratingActions: false };
            return copy;
          });
        });
    });
  };
  useEffect(() => {
    // Initialize actionGenerationTimeouts if it doesn't exist
    if (!window.actionGenerationTimeouts) {
      window.actionGenerationTimeouts = {};
    }

    // Return a cleanup function to clear all timeouts when the component unmounts
    return () => {
      // Clear all action generation timeouts
      if (window.actionGenerationTimeouts) {
        Object.values(window.actionGenerationTimeouts).forEach((timeout) => {
          clearTimeout(timeout);
        });
      }

      // Clear all action application timeouts
      if (window.actionTimeouts) {
        Object.values(window.actionTimeouts).forEach((timeout) => {
          clearTimeout(timeout);
        });
      }
    };
  }, [
    // list out all the dependencies you care about:
    campaigns
      .map((c) =>
        [
          c.mailDate,
          c.clientIds.join(","),
          c.itemEstimation.map((i) => i.product_variation_id + ":" + i.qtyPerOrder).join(","),
          c.mailStockData.map((d) => d.stock + ":" + d.needed).join(","),
          c.targetMailQty,
        ].join("|")
      )
      .join(";;"),
  ]);

  const handleDeleteCampaign = async (idx) => {
    const campaign = campaigns[idx];

    // If it exists on the backend, delete there first
    if (campaign.id) {
      try {
        await deleteMediaPlan(campaign.id);
        message.success(`Campaign ${campaign.code} deleted from server.`);
      } catch (err) {
        console.error("Failed to delete campaign:", err);
        message.error(
          `Could not delete campaign ${campaign.code}: ${err.response?.data?.detail || err.message}`
        );
        return;
      }
    }

    // In any case, remove locally
    setCampaigns((prev) => prev.filter((_, i) => i !== idx));
    message.success(`Campaign ${campaign.code} removed.`);
  };

  const totalQtyNeeded = campaigns?.reduce(
    (sum, c) => sum + Number(c.targetMailQty || c.mailQty || 0),
    0
  );

  // Function to apply suggested actions to a campaign
  const applyAction = (campaignIdx, action, offerItemDescription) => {
    setCampaigns((prevCampaigns) => {
      const updatedCampaigns = [...prevCampaigns];
      const campaign = { ...updatedCampaigns[campaignIdx] };

      switch (action.type) {
        case "change_mail_date":
          // Update mail date
          campaign.mailDate = dayjs(action.newDate);
          message.success(`Mail date changed to ${action.newDate}`);
          break;

        case "combined_date_and_order":
          // Update mail date and show message about ordering
          campaign.mailDate = dayjs(action.newDate);
          message.success(`Mail date changed to ${action.newDate}`);
          message.warning(
            `Please remember to order ${action.orderAmount.toLocaleString()} units to ensure sufficient stock by the mail date. Estimated stock on that date without ordering would be ${Math.round(
              action.estimatedStock
            )} units.`
          );
          break;

        case "emergency_combined_action":
          // Update mail date and show message about emergency ordering
          campaign.mailDate = dayjs(action.newDate);
          message.success(`Mail date changed to ${action.newDate}`);
          message.warning(
            `URGENT: Please order ${action.orderAmount.toLocaleString()} units immediately to ensure sufficient stock by the mail date.`
          );
          break;

        case "reduce_mail_qty":
          // Update mail quantity
          campaign.mailQty = action.newQty;
          campaign.targetMailQty = action.newQty;
          message.success(`Mail quantity reduced to ${action.newQty.toLocaleString()}`);
          break;

        case "reduce_mail_qty_print":
          // Update mail quantity due to print stock limitations
          campaign.mailQty = action.newQty;
          campaign.targetMailQty = action.newQty;
          message.success(
            `Mail quantity reduced to ${action.newQty.toLocaleString()} due to print stock limitations`
          );
          break;

        default:
          message.warning(
            `Action type '${action.type}' is not supported for automatic application`
          );
          return prevCampaigns;
      }

      // Remove the applied action from suggestedActions
      const updatedSuggestedActions = { ...campaign.suggestedActions };
      if (updatedSuggestedActions[offerItemDescription]) {
        updatedSuggestedActions[offerItemDescription] = updatedSuggestedActions[
          offerItemDescription
        ].filter((a) => a !== action);

        // If no more actions for this item, remove the key
        if (updatedSuggestedActions[offerItemDescription].length === 0) {
          delete updatedSuggestedActions[offerItemDescription];
        }
      }

      campaign.suggestedActions = updatedSuggestedActions;

      // For date change actions, we don't need to regenerate actions
      // Just show a confirmation message and update the state
      const isDateChangeAction = [
        "change_mail_date",
        "combined_date_and_order",
        "emergency_combined_action",
      ].includes(action.type);

      if (isDateChangeAction) {
        // For date changes, add a specific confirmation message
        if (
          action.type === "combined_date_and_order" ||
          action.type === "emergency_combined_action"
        ) {
          message.info(
            "Action applied. Please remember to place the necessary order as indicated above.",
            5
          );
        } else {
          message.info(
            "Date change applied successfully. No further actions needed at this time.",
            5
          );
        }

        // No need to regenerate actions or show loading state
        campaign.isGeneratingActions = false;
      } else {
        // For other actions (like quantity reduction), we might want to regenerate actions
        // to see if there are any new recommendations
        campaign.isGeneratingActions = true;

        // Force regeneration by clearing the last action key for this campaign
        setLastActionKeys((prev) => {
          const updated = { ...prev };
          delete updated[campaignIdx];
          return updated;
        });

        // Set a safety timeout to ensure loading state is reset even if no new actions are generated
        // This prevents the loading indicator from continuing indefinitely
        const safetyTimeout = setTimeout(() => {
          setCampaigns((prevCampaigns) => {
            // Only update if still loading
            if (prevCampaigns[campaignIdx]?.isGeneratingActions) {
              const updatedCampaigns = [...prevCampaigns];
              updatedCampaigns[campaignIdx] = {
                ...updatedCampaigns[campaignIdx],
                isGeneratingActions: false,
              };
              return updatedCampaigns;
            }
            return prevCampaigns;
          });
        }, 5000); // 5 seconds should be enough for action generation

        // Store the timeout ID to clear it if component unmounts
        // This prevents memory leaks
        if (window.actionTimeouts === undefined) {
          window.actionTimeouts = {};
        }

        // Clear any existing timeout for this campaign
        if (window.actionTimeouts[campaignIdx]) {
          clearTimeout(window.actionTimeouts[campaignIdx]);
        }

        // Store the new timeout
        window.actionTimeouts[campaignIdx] = safetyTimeout;
      }

      updatedCampaigns[campaignIdx] = campaign;
      return updatedCampaigns;
    });
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "accessToken" && event.newValue === null) {
        sessionStorage.removeItem("mediaPlanDraft");
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <div style={{ maxWidth: "100vw", height: "100vh" }}>
      <PanelGroup direction="horizontal">
        <Panel2 defaultSize={70} minSize={30}>
          <div
            style={{
              padding: 16,
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              minWidth: 0,
              borderRight: "1px solid #f0f0f0",
            }}>
            <CampaignsPanel
              campaigns={campaigns}
              onDuplicate={handleDuplicateCampaign}
              onDelete={handleDeleteCampaign}
              onChange={handleCampaignChange}
              onSave={handleSaveCampaign}
              strategyOptions={strategyOptions}
              statusOptions={statusOptions}
              brandOptions={brandOptions}
              disabled={isSaving}
              handleBrandChange={handleBrandChange}
              handleProductChange={handleProductChange}
              handleOfferChange={handleOfferChange}
              applyAction={applyAction}
              defaultActiveKey={campaigns.length > 0 ? campaigns[0].code : undefined}
              mode={urlMode} // Pass the mode to control field editability and button visibility
              onViewOfferDetails={(offer) => {
                setSelectedOfferId(offer.id);
                setIsOfferDetailsVisible(true);
              }}
            />
            <button
              type="button"
              className="btn btn-primary"
              onClick={generatingNewActions}
              disabled={isSaving}>
              Create Actions
            </button>

            <Collapse bordered={false} style={{ marginTop: 16, minWidth: 0 }}>
              <Collapse.Panel
                header={<div>Lists Selection</div>}
                extra={
                  <span style={{ fontWeight: 500 }}>
                    Total Qty Needed:{" "}
                    <span style={{ color: "#1890ff" }}>{totalQtyNeeded.toLocaleString()}</span>
                  </span>
                }
                key="lists-selection"
                style={{ minWidth: 0 }}>
                <ListsBlock
                  listOptions={listOptions}
                  AlllistOptions={AlllistOptions}
                  segmentAllOptions={segmentAllOptions}
                  totalQtyNeeded={totalQtyNeeded}
                  selectedList={selectedList}
                  setSelectedList={setSelectedList}
                  segmentOptions={segmentOptions}
                  selectedSegment={selectedSegment}
                  setSelectedSegment={setSelectedSegment}
                  priority={priority}
                  setPriority={setPriority}
                  testContOptions={testContOptions}
                  selectTestCont={selectTestCont}
                  setSelectTestCont={setSelectTestCont}
                  maxAllOptions={maxAllOptions}
                  selectMaxAll={selectMaxAll}
                  setSelectMaxAll={setSelectMaxAll}
                  comment={comment}
                  setComment={setComment}
                  setSourceCode={setSourceCode}
                  productCategory={productCategory}
                  setProductCategory={setProductCategory}
                  performance={performance}
                  setPerformance={setPerformance}
                  cost={cost}
                  setCost={setCost}
                  shipQty={shipQty}
                  setShipQty={setShipQty}
                  mailQty={mailQty}
                  setMailQty={setMailQty}
                  handleSaveList={handleSaveList}
                  transformedLists={transformedLists}
                  onListCreated={handleListCreated}
                  onSegmentsUpdated={fetchSegments}
                  campaigns={campaigns}
                />
              </Collapse.Panel>
            </Collapse>
            {urlMode !== "view" && (
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  onClick={() => {
                    Modal.confirm({
                      title: "Are you sure?",
                      content: "You have unsaved changes. Do you really want to cancel?",
                      okText: "Yes, cancel",
                      cancelText: "No, keep editing",
                      onOk: () => {
                        // onClose();
                        sessionStorage.removeItem("mediaPlanDraft");
                        // navigate("/media-plans");
                        window.location.reload();
                      },
                    });
                  }}>
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveAllCampaigns}
                  disabled={isSaving}>
                  Save All
                </button>
              </div>
            )}
          </div>
        </Panel2>
        <PanelResizeHandle
          style={{
            width: "2px",
            background: "#ccc",
            cursor: "col-resize",
          }}
        />
        <Panel2 defaultSize={30} minSize={20}>
          <div style={{ height: "100%", overflowY: "auto" }}>
            {isOfferDetailsVisible ? (
              <OfferDetailsView
                isVisible={isOfferDetailsVisible}
                onClose={() => setIsOfferDetailsVisible(false)}
                offerId={selectedOfferId}
                clientId={currentClientId}
                ref={offerDetailsSidebarRef}
                editMode={false}
                toggleEdit={() => {
                  //
                }}
                onResize={setOfferDetailsSidebarWidth}
              />
            ) : (
              <SupportInfoPanel
                campaigns={campaigns}
                // renderCampaignInfoPanel is put inside the <React.Suspense> by Zaman.
                // inside the component there is a time taking fetching
                campaignInfoPanel={
                  <React.Suspense fallback={<div>Loading campaign info...</div>}>
                    {renderCampaignInfoPanel()}
                  </React.Suspense>
                  // renderCampaignInfoPanel()
                }
                productStockPanel={renderProductStockPanel()}
                printersStockPanel={renderPrintersStockPanel()}
                orderEvolutionPanel={renderOrderEvolutionPanel()}
                costsPanel={renderCostsPanel()}
              />
            )}
          </div>
        </Panel2>
      </PanelGroup>
    </div>
  );
};
export default EditMediaPlan;
